import {
  Eater,
  IGenerateCustomEater,
  Restaurant,
  RestaurantAndPredictedRestaurant,
  RestaurantResponse,
} from '../types'
import { ICampaign as IAdminCampaign } from '../types/influencerType'
import { ICampaign } from '../types/contentCreatorTypes'
import { Item } from '../types/restaurantTypes'
import { DEFAULT_CARD_IMAGE, socialPlatforms } from './static-constants'

export const mapToItems = (restaurant: RestaurantResponse): Item => {
  // eslint-disable-next-line
  const description =
    restaurant?.restaurantDTO?.description?.length &&
    restaurant.restaurantDTO.description?.length > 150
      ? `${restaurant?.restaurantDTO?.description?.slice(0, 120)}...`
      : restaurant.restaurantDTO.description ?? ''
  const restaurantDTO = restaurant.restaurantDTO
  return {
    name:
      restaurantDTO.name.length > 30
        ? `${restaurantDTO.name.slice(0, 15)}...`
        : restaurantDTO.name,
    alias: restaurantDTO.alias,
    label: restaurant.label ?? 'Yes',
    starCount: restaurant.starCount,
    probability: `${restaurant.value ?? 0}`,
    // eslint-disable-next-line
    description: description,
    price: restaurantDTO?.priceRange ?? '0',
    distance: restaurantDTO?.distance ?? 0,
    image: restaurantDTO?.imageUrl,
    navigate: restaurantDTO
      ? 'https://www.google.com/maps/dir/?api=1&destination=' +
        generateAddress(restaurantDTO)
      : 'https://www.google.com/maps/dir/?api=1&destination=',
    saved: restaurant.restaurantDTO?.saved ?? false,
    group: restaurant.group,
    groupprobability: restaurant.groupValue,
    grouprecommendations: restaurant.groupRecommendations,
    verified: restaurant?.restaurantDTO?.verified,
    open: restaurant.restaurantDTO.open,
    weekdayText: restaurant.restaurantDTO.weekdayText,
  }
}

export const generateAddress = (restaurant: Restaurant): string => {
  const address = `${restaurant?.address1 ??''} ${restaurant?.city ??''}, ${
    restaurant?.state ?? ''
  } ${restaurant.zipCode ?? ''}`
  return encodeURIComponent(address.trim())
}

export const generateEater = (eater: Eater): IGenerateCustomEater => {
  const {
    firstName,
    lastName,
    eaterId,
    email,
    phone,
    addressLine1,
    addressLine2,
    city,
    state,
    zipcode,
    country,
    instagram,
    facebook,
    x,
    tiktok,
    occupation,
    imageUrl,
  } = eater
  const userName = `${firstName ?? ''} ${lastName ?? ''}`.trim()

  return {
    eaterId: eaterId ?? '',
    firstName: firstName ?? '',
    lastName: lastName ?? '',
    fullName: userName,
    email: email ?? '',
    phone: phone ?? '',
    addressLine1: addressLine1 ?? '',
    addressLine2: addressLine2 ?? '',
    city: city ?? '',
    state: state ?? '',
    zipcode: zipcode ?? '',
    country: country ?? '',
    instagram: instagram ?? '',
    facebook: facebook ?? '',
    x: x ?? '',
    tiktok: tiktok ?? '',
    occupation: occupation ?? '',
    imageUrl: imageUrl ?? DEFAULT_CARD_IMAGE,
  }
}

export const convertToPredictedAndPublicRestaurantList = (
  restaurants: Restaurant[],
): RestaurantAndPredictedRestaurant[] => {
  return restaurants.map((restaurant) => {
    // Normalize imageUrl - handle both imageUrl and imageurl from API
    const restaurantWithLegacy = restaurant as Restaurant & {
      imageurl?: string
    }
    const normalizedRestaurant: Restaurant = {
      ...restaurant,
      imageUrl: restaurant.imageUrl ?? restaurantWithLegacy.imageurl,
    }
    return {
      restaurantDTO: normalizedRestaurant,
      label: restaurant.name,
      value: undefined,
      groupValue: undefined,
      starCount: undefined,
      recommendation: undefined,
      groupRecommendations: [],
      group: false,
    }
  })
}
export const convertToPredictedAndPublicRestaurant = (
  restaurant: Restaurant,
): RestaurantAndPredictedRestaurant => {
  // Normalize imageUrl - handle both imageUrl and imageurl from API
  const restaurantWithLegacy = restaurant as Restaurant & {
    imageurl?: string
  }
  const normalizedRestaurant: Restaurant = {
    ...restaurant,
    imageUrl: restaurant.imageUrl ?? restaurantWithLegacy.imageurl,
  }
  return {
    restaurantDTO: normalizedRestaurant,
    label: restaurant.name,
    value: undefined,
    groupValue: undefined,
    starCount: undefined,
    recommendation: undefined,
    groupRecommendations: [],
    group: false,
  }
}

export const convertAdminCampaignToCampaign = (
  admin: IAdminCampaign,
  id?: string,
): ICampaign => {
  const social = socialPlatforms.reduce((acc, platform) => {
    if (admin?.platforms?.includes(platform)) {
      acc[platform] = ''
    }
    return acc
  }, {})

  return {
    ...(id && { id }),
    title: admin.name,
    description: admin.description,
    location: admin?.location?.join(', '),
    bidPrice: `${admin.budget.min} - ${admin.budget.max}`,
    social,
  }
}
